import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { HIDDEN, FADE } from '../../HOME/const';
import ResetStatsIcon from '../../HOME/SVG/ResetStatsIcon';
import VolumeControl from '../../HOME/COMPONENTS/VolumeControl';
import { setOver } from '../REDUX/actions';
import { goToPage, setGlobalOption, requestResetStats } from '../../HOME/REDUX/actions';

const Options = props => {
  const handleResetStats = e => {
    if (canResetStats()) {
      props.hideOptions();
      props.requestResetStats(true);
    }
  };

  const canResetStats = () => {
    const { practice, stats } = props;
    return !practice && stats && stats.plays > 0;
  };

  const { op } = props;
  const optionsVisibility = op === HIDDEN ? 'none' : 'inline';

  return (
    <div className={`options ${op === FADE ? 'fadeout' : 'fadein-fast'}`} style={{ display: optionsVisibility }}>
      <div className="options-x" onClick={props.hideOptions}>
        ×
      </div>
      <div className={`options-item${canResetStats() ? '' : ' options-item-disabled'}`} onClick={handleResetStats}>
        <ResetStatsIcon width="30" />
        <span>reset stats</span>
      </div>
      <VolumeControl />
    </div>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, requestResetStats, setGlobalOption, setOver }
)(Options);
